// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: relative;
}

.dialog-wrapper {
  position: relative;
}

.download-overlay {
  position: absolute;
  inset: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.75);
  border-radius: 4px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  gap: 12px;
}

mat-dialog-content {
  min-width: 600px;
  min-height: 200px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
}

.content {
  padding: 16px;
  border-radius: 4px;
  position: relative;
}

.upload-status-text {
  margin: 0;
  color: #555;
  font-size: 0.9rem;
}

.upload-error-text {
  color: #c62828;
  font-size: 0.85rem;
  margin-bottom: 8px;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.field-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}

.field-label {
  flex: 0 0 140px;
  padding-top: 6px;
  font-size: 0.85rem;
}

.field-value {
  flex: 1;
}

.field-error {
  color: #dc3545;
  font-size: 0.75rem;
  margin-top: 2px;
}

.button-gap {
  gap: 12px;
}

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/projects-dashboard/well-attachments-dialog/well-attachments-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX","sourcesContent":[":host {\n  position: relative;\n}\n\n.dialog-wrapper {\n  position: relative;\n}\n\n.download-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  background: rgba(255, 255, 255, 0.75);\n  border-radius: 4px;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n  gap: 12px;\n}\n\nmat-dialog-content {\n  min-width: 600px;\n  min-height: 200px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n  position: relative;\n}\n\n.upload-status-text {\n  margin: 0;\n  color: #555;\n  font-size: 0.9rem;\n}\n\n.upload-error-text {\n  color: #c62828;\n  font-size: 0.85rem;\n  margin-bottom: 8px;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.field-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.field-label {\n  flex: 0 0 140px;\n  padding-top: 6px;\n  font-size: 0.85rem;\n}\n\n.field-value {\n  flex: 1;\n}\n\n.field-error {\n  color: #dc3545;\n  font-size: 0.75rem;\n  margin-top: 2px;\n}\n\n.button-gap {\n  gap: 12px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
